import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      width: "60rem"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_vm.mvtStock ? _c(VCard, {
    staticClass: "mvt-stock-dialog"
  }, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: _vm.cancel
    }
  })], 1), _c("div", {
    staticClass: "user-infos"
  }, [_c("h2", {
    staticClass: "text-small"
  }, [_vm._v("Manual adjustment")]), _c("div", {
    staticClass: "user-infos-details"
  }, [_c("div", [_c(VTextField, {
    attrs: {
      label: "Name",
      readonly: ""
    },
    model: {
      value: _vm.mvtStock.user_initiator.fullname,
      callback: function callback($$v) {
        _vm.$set(_vm.mvtStock.user_initiator, "fullname", $$v);
      },
      expression: "mvtStock.user_initiator.fullname"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Email",
      readonly: ""
    },
    model: {
      value: _vm.mvtStock.user_initiator.login,
      callback: function callback($$v) {
        _vm.$set(_vm.mvtStock.user_initiator, "login", $$v);
      },
      expression: "mvtStock.user_initiator.login"
    }
  })], 1)])]), !_vm.isEditing ? _c("div", {
    staticClass: "mvtstock-infos"
  }, [_c("div", {
    staticClass: "form-label v-label theme--light flex"
  }, [_c("span", [_vm._v("Reason")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: true
    },
    on: {
      click: function click() {
        return _vm.isEditing = true;
      }
    }
  }, [_vm._v(" Edit ")])], 1), _c("div", {
    staticClass: "form-message",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.mvtStock.mvt_reasons))
    }
  })]) : _c(VTextarea, {
    staticClass: "px-0",
    attrs: {
      "hide-details": "auto",
      outlined: ""
    },
    model: {
      value: _vm.reason,
      callback: function callback($$v) {
        _vm.reason = $$v;
      },
      expression: "reason"
    }
  }), _vm.isEditing ? [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: true
    },
    on: {
      click: function click() {
        _vm.isEditing = false;
        _vm.isSaving = false;
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: true,
      loading: _vm.isSaving
    },
    on: {
      click: _vm.saveReason
    }
  }, [_vm._v(" Save ")])] : _vm._e()], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };